import type { SerializedStyles } from "@emotion/react"
import { css } from "@emotion/react"
import { useMemo } from "react"

import Image from "../../html/Image"

import spinnerGif from "./spinner.gif"

type Props = {
  theme?: "dark" | "light"
  children?: React.ReactNode
  zIndex?: number
  fullScreen?: boolean
  message?: string
  spinnerStyle?: SerializedStyles
  spinner?: React.ReactNode
}

const LoadingOverlay = ({
  theme = "dark",
  children,
  zIndex = 1,
  fullScreen = false,
  message,
  spinnerStyle,
  spinner,
}: Props) => {
  const style = useMemo(() => overlayStyle(zIndex, theme, fullScreen), [theme, zIndex, fullScreen])
  const msgStyle = useMemo(() => messageStyle(theme), [theme])

  const defaultSpinner = <Image src={spinnerGif} width={64} height={64} alt="" css={spinnerStyle} />

  return (
    <div css={style}>
      {message && <div css={msgStyle}>{message}</div>}
      {children || spinner || defaultSpinner}
    </div>
  )
}

export default LoadingOverlay

const overlayStyle = (zIndex: number, theme: "dark" | "light", fullScreen: boolean) => css`
  position: ${fullScreen ? "fixed" : "absolute"};
  top: ${fullScreen ? "0" : "auto"};
  left: ${fullScreen ? "0" : "auto"};
  z-index: ${zIndex};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${theme === "dark" ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.7)"};
`
const messageStyle = (theme: "dark" | "light") => css`
  margin-bottom: 16px;
  color: ${theme === "dark" ? "#fff" : "#000"};
  font-size: 16px;
  text-align: center;
`
